import React, { useEffect, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, } from '@mui/material';
import { LoadingButton } from '@mui/lab';
export const TradingActivityConfirmationDialog = ({ open, settingsData, loading, onClose, onConfirm, }) => {
    const [confirmationText, setConfirmationText] = useState('');
    useEffect(() => {
        if (open) {
            setConfirmationText('');
        }
    }, [open]);
    if (!open || !settingsData) {
        return null;
    }
    const TradingOptions = {
        buy_disabled: 'BUY activity',
        sell_disabled: 'SELL activity',
        withdrawal_disabled: 'WITHDRAWAL activity',
    };
    const { client, setting, value } = settingsData;
    const settingName = TradingOptions[setting] || setting;
    const clientName = (client === null || client === void 0 ? void 0 : client.company_name) || 'this client';
    const isDisabling = value;
    const isConfirmationDisabled = confirmationText !== clientName || loading;
    return (React.createElement(Dialog, { open: open, maxWidth: 'sm', fullWidth: true, onClose: onClose },
        React.createElement(DialogTitle, null,
            isDisabling ? 'Disable' : 'Enable',
            " ",
            settingName,
            "?"),
        React.createElement(DialogContent, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
            React.createElement(Alert, { color: 'error', severity: 'error', variant: 'outlined' },
                "You are about to ",
                React.createElement("span", { color: 'error' }, isDisabling ? 'DISABLE' : 'ENABLE'),
                ' ',
                React.createElement("b", { color: 'error' }, settingName),
                " for the client ",
                React.createElement("b", null, clientName)),
            React.createElement(Typography, { variant: 'body2' },
                "To confirm, please type ",
                clientName,
                " below:"),
            React.createElement(TextField, { size: 'small', placeholder: `Type ${clientName} to confirm`, value: confirmationText, onChange: (e) => {
                    setConfirmationText(e.target.value);
                } })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: onClose }, "Cancel"),
            React.createElement(LoadingButton, { disabled: isConfirmationDisabled, variant: 'contained', onClick: onConfirm }, "Yes, update setting"))));
};
